module.exports = __webpack_public_path__ + "static/media/42039617f32496eaad226365b2b2d279.5e964755.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/42039617f32496eaad226365b2b2d279.jpg
// module id = 261
// module chunks = 0